// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.article-content {
  max-width: 53vw;
  margin: 40px auto;
  padding: 0 20px;
}

@media (min-width: 1500px) {
  .article-content {
    padding: 0 3vw;
  }
  .article-body {
    padding-left: 15px;
    padding-right: 15px;
  }
}

.article-body {
  font-size: 18px;
  line-height: 1.8;
  color: var(--text-primary);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Georgia, serif;
  letter-spacing: 0.3px;
}

@media (min-width: 1299px) and (max-width: 1500px) {
  .article-body {
    padding-left: 15px;
    padding-right: 15px;
  }
}

@media (max-width: 1159.9px) {
  .article-content {
    max-width: 70vw;
  }
}

@media (max-width: 768px) {
  .article-content {
    max-width: 85vw;
  }
}

@media (max-width: 600px) {
  .article-content {
    max-width: 100%;
  }
}

/* Typography enhancements */
.article-body p {
  margin: 1.5em 0;
  text-align: justify;
  text-justify: inter-word;
  hyphens: auto;
}

.article-body p:first-child {
  font-size: 1.1em;
  font-weight: 500;
  color: var(--text-primary);
  line-height: 1.9;
}

/** Headings */
.article-body h1,
.article-body h2,
.article-body h3,
.article-body h4,
.article-body h5,
.article-body h6 {
  margin: 1.5em 0 0.75em;
  font-weight: 700;
  line-height: 1.3;
  scroll-margin-top: 100px;
  transition: all 0.3s;
}

.article-body h1 {
  font-size: 2.2em;
  color: var(--text-primary);
  border-bottom: 3px double var(--accent-primary);
  padding-bottom: 12px;
}

.article-body h2 {
  font-size: 1.8em;
  color: var(--text-primary);
  margin-top: 2em;
}

.article-body h3 {
  font-size: 1.4em;
  color: var(--text-primary);
  margin-top: 1.5em;
}

.article-body h4 {
  font-size: 1.1em;
  color: var(--text-primary);
  font-weight: 600;
}

.article-body h5,
.article-body h6 {
  font-size: 1em;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--text-secondary);
}

/* Lists */
.article-body ul,
.article-body ol {
  margin: 1.5em 0;
  padding-left: 2em;
  line-height: 1.8;
}

.article-body li {
  margin: 0.5em 0;
  color: var(--text-primary);
}

.article-body li p {
  margin: 0.5em 0;
}

.article-body ul > li::marker {
  color: var(--accent-primary);
  font-weight: 700;
}

.article-body ol > li::marker {
  color: var(--accent-primary);
  font-weight: 700;
}

/* Blockquotes */
.article-body blockquote {
  margin: 1.5em 0;
  padding: 20px 24px;
  border-left: 5px solid var(--accent-primary);
  background: var(--bg-secondary);
  border-radius: 6px;
  font-style: italic;
  color: var(--text-secondary);
  line-height: 1.8;
}

.article-body blockquote p {
  margin: 0.5em 0;
  text-align: left;
}

.article-body blockquote strong {
  color: var(--text-primary);
  font-weight: 700;
}

.article-body blockquote em {
  color: var(--text-primary);
}

/* Code blocks */
.article-body pre {
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 16px;
  overflow-x: auto;
  margin: 1.5em 0;
  font-size: 14px;
  line-height: 1.6;
}

.article-body code {
  font-family: 'Monaco', 'Courier New', monospace;
  color: var(--accent-primary);
}

.article-body pre code {
  color: var(--text-primary);
  font-size: 0.95em;
}

/* Inline code */
.article-body p code,
.article-body li code {
  background: var(--bg-tertiary);
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.9em;
}

/* Links */
.article-body a {
  color: var(--accent-primary);
  text-decoration: underline;
  transition: all 0.2s;
  word-break: break-word;
}

.article-body a:hover {
  color: var(--accent-hover);
  -webkit-text-decoration: underline wavy var(--accent-hover);
          text-decoration: underline wavy var(--accent-hover);
  background: var(--bg-tertiary);
  padding: 2px 4px;
  border-radius: 3px;
}

.article-body a::after {
  content: '';
  margin-left: 2px;
}

/* External links */
.article-body a[target="_blank"]::after {
  content: ' ↗';
  font-size: 0.85em;
  opacity: 0.7;
}

/*
 * When an external-link anchor wraps an image (actifit app-store badges, etc.)
 * inside a centered container, the ↗ pseudo-element would otherwise sit at the
 * text baseline — far below the image.  Force it to the vertical midpoint.
 */
.article-body .text-center a[target="_blank"]::after,
.article-body center a[target="_blank"]::after,
.article-body [align="center"] a[target="_blank"]::after {
  vertical-align: middle;
}

/* Images */
.article-body img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 2em auto;
  display: block;
  border: 2px solid var(--border-color);
  transition: all 0.3s;
  cursor: zoom-in;
}

/* Images in centered containers should stay inline to display side-by-side */
.article-body .text-center img,
.article-body center img,
.article-body [align="center"] img {
  display: inline-block;
  margin: 0 4px;
}

.article-body img:hover {
  border-color: var(--accent-primary);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
}

/* Image captions */
.article-body figure {
  margin: 2em 0;
  text-align: center;
}

.article-body figcaption {
  font-size: 0.9em;
  color: var(--text-secondary);
  font-style: italic;
  margin-top: 8px;
}

/* Videos and iframes */
.article-body video {
  max-width: 100%;
  width: 100%;
  height: auto;
  display: block;
  margin: 2em auto;
  border-radius: 8px;
}

/*
 * Raw iframes that appear directly in post HTML (e.g. video embeds written as
 * <iframe width="640" …>) must be clamped to the container.  The HTML \`width\`
 * attribute is treated by browsers as a presentational hint, so \`max-width\`
 * overrides it per the CSS cascade.  \`aspect-ratio\` + \`height: auto\` ensures
 * the iframe stays proportional once the width is constrained.
 *
 * NOTE: .video-embed-container iframe (MarkdownRenderer.css) has equal
 * specificity but loads later, so \`height: 100%\` there still wins for
 * React-rendered embeds that already have a proper responsive wrapper.
 */
.article-body iframe {
  max-width: 100%;
  width: 100%;
  aspect-ratio: 16 / 9;
  height: auto;
  display: block;
  margin: 2em auto;
  border: none;
  border-radius: 8px;
}

/* Horizontal rule */
.article-body hr {
  margin: 2em 0;
  border: none;
  border-top: 3px dashed var(--border-color);
  opacity: 0.6;
}

.article-body hr:hover {
  opacity: 1;
  border-top-color: var(--accent-primary);
}

/* Strong and emphasis */
.article-body strong {
  font-weight: 700;
  color: var(--text-primary);
}

.article-body em {
  font-style: italic;
  color: var(--text-primary);
}

.article-body strong em {
  font-weight: 700;
  font-style: italic;
  color: var(--accent-primary);
}

/* Tables - defer to MarkdownRenderer table styling for consistency with FlexDetail */
.article-body .markdown-table {
  width: 100%;
  border-collapse: collapse;
  margin: 1.5em 0;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  overflow: hidden;
}

.article-body .markdown-table th {
  background: var(--bg-tertiary);
  font-weight: 700;
  color: var(--text-primary);
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid var(--border-color);
}

.article-body .markdown-table td {
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid var(--border-color);
}

.article-body .markdown-table tr:hover {
  background: var(--bg-secondary);
}

.article-body .markdown-table tr:last-child td {
  border-bottom: none;
}

/*
 * Actifit-style tables: layout wrappers that contain no <td> at all.
 * Remove them from the layout entirely — the empty <tr> rows still produce a
 * hairline of height, and the block wrapper div occupies a line slot even with
 * margin: 0. display: none is the cleanest solution.
 */
.article-body .markdown-table:not(:has(td)) {
  display: none;
}
.article-body .table-wrapper:not(:has(td)) {
  display: none;
}

/* Mobile responsive */
@media (max-width: 1159.9px) {
  .article-content {
    max-width: 70vw;
  }
}

@media (max-width: 768px) {
  .article-content {
    margin: 20px auto;
    padding: 0 16px;
    max-width: 95vw;
  }

  .article-body {
    font-size: 17px;
    line-height: 1.7;
  }

  .article-body h1 {
    font-size: 1.8em;
  }

  .article-body h2 {
    font-size: 1.5em;
  }

  .article-body h3 {
    font-size: 1.2em;
  }

  .article-body p {
    text-align: left;
  }

  .article-body blockquote {
    padding: 16px 20px;
    margin-left: 0;
  }

  .article-body pre {
    padding: 12px;
    font-size: 13px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .article-body table {
    font-size: 0.9em;
  }

  .article-body th,
  .article-body td {
    padding: 10px 12px;
  }
}

/* Print CSS */
@media print {
  .article-content {
    max-width: 100%;
    padding: 0;
  }

  .article-body {
    color: #000;
    font-size: 14pt;
  }

  .article-body a {
    color: #0066cc;
    text-decoration: none;
  }

  .article-body a::after {
    content: ' [' attr(href) ']';
    font-size: 0.8em;
    color: #666;
  }

  .article-body img {
    max-width: 100%;
    page-break-inside: avoid;
  }

  .article-body h1,
  .article-body h2,
  .article-body h3 {
    page-break-after: avoid;
  }

  .article-body p {
    orphans: 3;
    widows: 3;
  }
}

/* Dark theme optimizations */
[data-theme="dark"] .article-body {
  color: #e0e0e0;
}

[data-theme="dark"] .article-body blockquote {
  background: rgba(255, 255, 255, 0.05);
  color: #b0b0b0;
}

[data-theme="dark"] .article-body pre {
  background: rgba(0, 0, 0, 0.3);
}

/* Reading mode - focus only on content */
.article-body.focus-mode {
  opacity: 1;
}

.article-body.focus-mode a {
  text-decoration: none;
}

.article-body.focus-mode a:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/ArticleContent/ArticleContent.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,0EAA0E;EAC1E,qBAAqB;AACvB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,mBAAmB;EACnB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,cAAc;AACd;;;;;;EAME,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,+CAA+C;EAC/C,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,UAAU;AACV;;EAEE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,kBAAkB;EAClB,4CAA4C;EAC5C,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;;EAEE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,2DAAmD;UAAnD,mDAAmD;EACnD,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;;AAEA;;;;EAIE;AACF;;;EAGE,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,oBAAoB;EACpB,eAAe;AACjB;;AAEA,6EAA6E;AAC7E;;;EAGE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;;;;;;;EAUE;AACF;EACE,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,YAAY;EACZ,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,UAAU;EACV,uCAAuC;AACzC;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,qFAAqF;AACrF;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;EAKE;AACF;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;EACpB;AACF;;AAEA,cAAc;AACd;EACE;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,4BAA4B;IAC5B,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,wBAAwB;EAC1B;;EAEA;;;IAGE,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,SAAS;EACX;AACF;;AAEA,6BAA6B;AAC7B;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,yCAAyC;AACzC;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".article-content {\r\n  max-width: 53vw;\r\n  margin: 40px auto;\r\n  padding: 0 20px;\r\n}\r\n\r\n@media (min-width: 1500px) {\r\n  .article-content {\r\n    padding: 0 3vw;\r\n  }\r\n  .article-body {\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n  }\r\n}\r\n\r\n.article-body {\r\n  font-size: 18px;\r\n  line-height: 1.8;\r\n  color: var(--text-primary);\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Georgia, serif;\r\n  letter-spacing: 0.3px;\r\n}\r\n\r\n@media (min-width: 1299px) and (max-width: 1500px) {\r\n  .article-body {\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n  }\r\n}\r\n\r\n@media (max-width: 1159.9px) {\r\n  .article-content {\r\n    max-width: 70vw;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .article-content {\r\n    max-width: 85vw;\r\n  }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .article-content {\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n/* Typography enhancements */\r\n.article-body p {\r\n  margin: 1.5em 0;\r\n  text-align: justify;\r\n  text-justify: inter-word;\r\n  hyphens: auto;\r\n}\r\n\r\n.article-body p:first-child {\r\n  font-size: 1.1em;\r\n  font-weight: 500;\r\n  color: var(--text-primary);\r\n  line-height: 1.9;\r\n}\r\n\r\n/** Headings */\r\n.article-body h1,\r\n.article-body h2,\r\n.article-body h3,\r\n.article-body h4,\r\n.article-body h5,\r\n.article-body h6 {\r\n  margin: 1.5em 0 0.75em;\r\n  font-weight: 700;\r\n  line-height: 1.3;\r\n  scroll-margin-top: 100px;\r\n  transition: all 0.3s;\r\n}\r\n\r\n.article-body h1 {\r\n  font-size: 2.2em;\r\n  color: var(--text-primary);\r\n  border-bottom: 3px double var(--accent-primary);\r\n  padding-bottom: 12px;\r\n}\r\n\r\n.article-body h2 {\r\n  font-size: 1.8em;\r\n  color: var(--text-primary);\r\n  margin-top: 2em;\r\n}\r\n\r\n.article-body h3 {\r\n  font-size: 1.4em;\r\n  color: var(--text-primary);\r\n  margin-top: 1.5em;\r\n}\r\n\r\n.article-body h4 {\r\n  font-size: 1.1em;\r\n  color: var(--text-primary);\r\n  font-weight: 600;\r\n}\r\n\r\n.article-body h5,\r\n.article-body h6 {\r\n  font-size: 1em;\r\n  text-transform: uppercase;\r\n  letter-spacing: 1px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n/* Lists */\r\n.article-body ul,\r\n.article-body ol {\r\n  margin: 1.5em 0;\r\n  padding-left: 2em;\r\n  line-height: 1.8;\r\n}\r\n\r\n.article-body li {\r\n  margin: 0.5em 0;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.article-body li p {\r\n  margin: 0.5em 0;\r\n}\r\n\r\n.article-body ul > li::marker {\r\n  color: var(--accent-primary);\r\n  font-weight: 700;\r\n}\r\n\r\n.article-body ol > li::marker {\r\n  color: var(--accent-primary);\r\n  font-weight: 700;\r\n}\r\n\r\n/* Blockquotes */\r\n.article-body blockquote {\r\n  margin: 1.5em 0;\r\n  padding: 20px 24px;\r\n  border-left: 5px solid var(--accent-primary);\r\n  background: var(--bg-secondary);\r\n  border-radius: 6px;\r\n  font-style: italic;\r\n  color: var(--text-secondary);\r\n  line-height: 1.8;\r\n}\r\n\r\n.article-body blockquote p {\r\n  margin: 0.5em 0;\r\n  text-align: left;\r\n}\r\n\r\n.article-body blockquote strong {\r\n  color: var(--text-primary);\r\n  font-weight: 700;\r\n}\r\n\r\n.article-body blockquote em {\r\n  color: var(--text-primary);\r\n}\r\n\r\n/* Code blocks */\r\n.article-body pre {\r\n  background: var(--bg-tertiary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  padding: 16px;\r\n  overflow-x: auto;\r\n  margin: 1.5em 0;\r\n  font-size: 14px;\r\n  line-height: 1.6;\r\n}\r\n\r\n.article-body code {\r\n  font-family: 'Monaco', 'Courier New', monospace;\r\n  color: var(--accent-primary);\r\n}\r\n\r\n.article-body pre code {\r\n  color: var(--text-primary);\r\n  font-size: 0.95em;\r\n}\r\n\r\n/* Inline code */\r\n.article-body p code,\r\n.article-body li code {\r\n  background: var(--bg-tertiary);\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  font-size: 0.9em;\r\n}\r\n\r\n/* Links */\r\n.article-body a {\r\n  color: var(--accent-primary);\r\n  text-decoration: underline;\r\n  transition: all 0.2s;\r\n  word-break: break-word;\r\n}\r\n\r\n.article-body a:hover {\r\n  color: var(--accent-hover);\r\n  text-decoration: underline wavy var(--accent-hover);\r\n  background: var(--bg-tertiary);\r\n  padding: 2px 4px;\r\n  border-radius: 3px;\r\n}\r\n\r\n.article-body a::after {\r\n  content: '';\r\n  margin-left: 2px;\r\n}\r\n\r\n/* External links */\r\n.article-body a[target=\"_blank\"]::after {\r\n  content: ' ↗';\r\n  font-size: 0.85em;\r\n  opacity: 0.7;\r\n}\r\n\r\n/*\r\n * When an external-link anchor wraps an image (actifit app-store badges, etc.)\r\n * inside a centered container, the ↗ pseudo-element would otherwise sit at the\r\n * text baseline — far below the image.  Force it to the vertical midpoint.\r\n */\r\n.article-body .text-center a[target=\"_blank\"]::after,\r\n.article-body center a[target=\"_blank\"]::after,\r\n.article-body [align=\"center\"] a[target=\"_blank\"]::after {\r\n  vertical-align: middle;\r\n}\r\n\r\n/* Images */\r\n.article-body img {\r\n  max-width: 100%;\r\n  height: auto;\r\n  border-radius: 8px;\r\n  margin: 2em auto;\r\n  display: block;\r\n  border: 2px solid var(--border-color);\r\n  transition: all 0.3s;\r\n  cursor: zoom-in;\r\n}\r\n\r\n/* Images in centered containers should stay inline to display side-by-side */\r\n.article-body .text-center img,\r\n.article-body center img,\r\n.article-body [align=\"center\"] img {\r\n  display: inline-block;\r\n  margin: 0 4px;\r\n}\r\n\r\n.article-body img:hover {\r\n  border-color: var(--accent-primary);\r\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n/* Image captions */\r\n.article-body figure {\r\n  margin: 2em 0;\r\n  text-align: center;\r\n}\r\n\r\n.article-body figcaption {\r\n  font-size: 0.9em;\r\n  color: var(--text-secondary);\r\n  font-style: italic;\r\n  margin-top: 8px;\r\n}\r\n\r\n/* Videos and iframes */\r\n.article-body video {\r\n  max-width: 100%;\r\n  width: 100%;\r\n  height: auto;\r\n  display: block;\r\n  margin: 2em auto;\r\n  border-radius: 8px;\r\n}\r\n\r\n/*\r\n * Raw iframes that appear directly in post HTML (e.g. video embeds written as\r\n * <iframe width=\"640\" …>) must be clamped to the container.  The HTML `width`\r\n * attribute is treated by browsers as a presentational hint, so `max-width`\r\n * overrides it per the CSS cascade.  `aspect-ratio` + `height: auto` ensures\r\n * the iframe stays proportional once the width is constrained.\r\n *\r\n * NOTE: .video-embed-container iframe (MarkdownRenderer.css) has equal\r\n * specificity but loads later, so `height: 100%` there still wins for\r\n * React-rendered embeds that already have a proper responsive wrapper.\r\n */\r\n.article-body iframe {\r\n  max-width: 100%;\r\n  width: 100%;\r\n  aspect-ratio: 16 / 9;\r\n  height: auto;\r\n  display: block;\r\n  margin: 2em auto;\r\n  border: none;\r\n  border-radius: 8px;\r\n}\r\n\r\n/* Horizontal rule */\r\n.article-body hr {\r\n  margin: 2em 0;\r\n  border: none;\r\n  border-top: 3px dashed var(--border-color);\r\n  opacity: 0.6;\r\n}\r\n\r\n.article-body hr:hover {\r\n  opacity: 1;\r\n  border-top-color: var(--accent-primary);\r\n}\r\n\r\n/* Strong and emphasis */\r\n.article-body strong {\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.article-body em {\r\n  font-style: italic;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.article-body strong em {\r\n  font-weight: 700;\r\n  font-style: italic;\r\n  color: var(--accent-primary);\r\n}\r\n\r\n/* Tables - defer to MarkdownRenderer table styling for consistency with FlexDetail */\r\n.article-body .markdown-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin: 1.5em 0;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n}\r\n\r\n.article-body .markdown-table th {\r\n  background: var(--bg-tertiary);\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  padding: 12px 16px;\r\n  text-align: left;\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.article-body .markdown-table td {\r\n  padding: 12px 16px;\r\n  text-align: left;\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.article-body .markdown-table tr:hover {\r\n  background: var(--bg-secondary);\r\n}\r\n\r\n.article-body .markdown-table tr:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n/*\r\n * Actifit-style tables: layout wrappers that contain no <td> at all.\r\n * Remove them from the layout entirely — the empty <tr> rows still produce a\r\n * hairline of height, and the block wrapper div occupies a line slot even with\r\n * margin: 0. display: none is the cleanest solution.\r\n */\r\n.article-body .markdown-table:not(:has(td)) {\r\n  display: none;\r\n}\r\n.article-body .table-wrapper:not(:has(td)) {\r\n  display: none;\r\n}\r\n\r\n/* Mobile responsive */\r\n@media (max-width: 1159.9px) {\r\n  .article-content {\r\n    max-width: 70vw;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .article-content {\r\n    margin: 20px auto;\r\n    padding: 0 16px;\r\n    max-width: 95vw;\r\n  }\r\n\r\n  .article-body {\r\n    font-size: 17px;\r\n    line-height: 1.7;\r\n  }\r\n\r\n  .article-body h1 {\r\n    font-size: 1.8em;\r\n  }\r\n\r\n  .article-body h2 {\r\n    font-size: 1.5em;\r\n  }\r\n\r\n  .article-body h3 {\r\n    font-size: 1.2em;\r\n  }\r\n\r\n  .article-body p {\r\n    text-align: left;\r\n  }\r\n\r\n  .article-body blockquote {\r\n    padding: 16px 20px;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .article-body pre {\r\n    padding: 12px;\r\n    font-size: 13px;\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n\r\n  .article-body table {\r\n    font-size: 0.9em;\r\n  }\r\n\r\n  .article-body th,\r\n  .article-body td {\r\n    padding: 10px 12px;\r\n  }\r\n}\r\n\r\n/* Print CSS */\r\n@media print {\r\n  .article-content {\r\n    max-width: 100%;\r\n    padding: 0;\r\n  }\r\n\r\n  .article-body {\r\n    color: #000;\r\n    font-size: 14pt;\r\n  }\r\n\r\n  .article-body a {\r\n    color: #0066cc;\r\n    text-decoration: none;\r\n  }\r\n\r\n  .article-body a::after {\r\n    content: ' [' attr(href) ']';\r\n    font-size: 0.8em;\r\n    color: #666;\r\n  }\r\n\r\n  .article-body img {\r\n    max-width: 100%;\r\n    page-break-inside: avoid;\r\n  }\r\n\r\n  .article-body h1,\r\n  .article-body h2,\r\n  .article-body h3 {\r\n    page-break-after: avoid;\r\n  }\r\n\r\n  .article-body p {\r\n    orphans: 3;\r\n    widows: 3;\r\n  }\r\n}\r\n\r\n/* Dark theme optimizations */\r\n[data-theme=\"dark\"] .article-body {\r\n  color: #e0e0e0;\r\n}\r\n\r\n[data-theme=\"dark\"] .article-body blockquote {\r\n  background: rgba(255, 255, 255, 0.05);\r\n  color: #b0b0b0;\r\n}\r\n\r\n[data-theme=\"dark\"] .article-body pre {\r\n  background: rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n/* Reading mode - focus only on content */\r\n.article-body.focus-mode {\r\n  opacity: 1;\r\n}\r\n\r\n.article-body.focus-mode a {\r\n  text-decoration: none;\r\n}\r\n\r\n.article-body.focus-mode a:hover {\r\n  text-decoration: underline;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
